import { all, spawn } from 'redux-saga/effects';

import watchSession from 'store/session/sagas';
import watchAttributes from 'store/attributes/sagas';

export default function* watcher() {
  yield all([spawn(watchSession), spawn(watchAttributes)]);
}
